import { render } from "./TermosSection.vue?vue&type=template&id=7172342e&scoped=true"
import script from "./TermosSection.vue?vue&type=script&lang=js"
export * from "./TermosSection.vue?vue&type=script&lang=js"

import "./TermosSection.vue?vue&type=style&index=0&id=7172342e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7172342e"]])

export default __exports__